module.exports = __webpack_public_path__ + "img/av (1).5ad4ffb6.png";